module.exports = __webpack_public_path__ + "static/media/dgs2.png.530f35d4.jpg";